import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-app/src/app/global-error.tsx");
